<template>
  <main>
    <HeroSection />

    <div class="grid-container">
      <EpomAd tag-style="relative" :placement-id="epomPlacementId" class="col-span-12 mt-4 mb-2" />
    </div>

    <NewJobOffers />

    <NewJobFeatures />

    <NewJobFacts />

    <NewJobPartners />

    <NewJobTestimonials />
  </main>
</template>

<script setup lang="ts">
import { EpomAd } from '@ramp106/omrjs-core-ui'

import HeroSection from '@/components/HeroSection.vue'
import NewJobFacts from '@/components/NewJob/NewJobFacts.vue'
import NewJobFeatures from '@/components/NewJob/NewJobFeatures.vue'
import NewJobOffers from '@/components/NewJob/NewJobOffers.vue'
import NewJobPartners from '@/components/NewJob/NewJobPartners.vue'
import NewJobTestimonials from '@/components/NewJob/NewJobTestimonials.vue'
import { useEpomPlacementId } from '@/composables'

const epomPlacementId = useEpomPlacementId()
</script>
